import React, { useEffect } from 'react';
import { LoadingSpinner } from '../../../../components/atoms/LoadingSpinner';
import { sendLiveRegionMessage } from '../../../../components/atoms/LiveRegionGlobal/LiveRegionGlobal';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

export function SubPanelLoadingSpinner() {
  const { t } = useSonTranslation('phrases');

  useEffect(() => {
    sendLiveRegionMessage(t('contentIsLoading'));
  }, []);

  return (
    <div className="main-navigation__sub-panel-loading">
      <div className="main-navigation__sub-panel-spinner">
        <LoadingSpinner />
      </div>
    </div>
  );
}
